import { combineReducers } from "redux";
import board from "./Board";
import auth from "./Auth";
import review from "./Review";
import popup from "./Popup";

const reducers = combineReducers({ board, auth, review, popup });

export default reducers;
